/* ZOALIN_PC_CARE_GUIDE_REFRESH_JS_20260723 */
(function () {
  function isCareGuide() {
    return window.location.pathname.replace(/\/+$/, '') === '/pages/care-guide';
  }

  function isDesktopPointer() {
    return window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  }

  function addStorageCard() {
    if (!isCareGuide() || !isDesktopPointer()) return;

    var grid = document.querySelector('.zoalin-info--care .zoalin-info__grid');
    if (!grid || grid.querySelector('.zoalin-info__card--storage')) return;

    var card = document.createElement('article');
    card.className = 'zoalin-info__card zoalin-info__card--storage';
    card.innerHTML = '<span class="zoalin-info__number">06</span><div><h2>Store softly</h2><p>Fold or hang pieces with room to breathe, away from direct sunlight and moisture.</p></div>';
    grid.appendChild(card);
    grid.classList.add('zoalin-care-grid-has-storage');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addStorageCard, { once: true });
  } else {
    addStorageCard();
  }

  window.setTimeout(addStorageCard, 500);
})();
